import I18n from 'I18n';
import { Tab, Tabs } from 'foundations-components/transitional/components/Tabs';
import { MY_LEARNING_TABS } from '../myLearningTypes';
import { getMyLearningUrl } from '../myLearningRouting';
import { useMyLearningParams } from '../myLearningHooks';
import useNavigate from '../../../hooks/useNavigate';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
export const MyLearningTabNavigation = () => {
  const navigate = useNavigate();
  const {
    tab: selectedTab
  } = useMyLearningParams();
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(Tabs, {
    marginBlockEnd: isMobile ? '600' : '500',
    selected: selectedTab,
    children: MY_LEARNING_TABS.map(tab => /*#__PURE__*/_jsx(Tab, {
      onClick: () => navigate(getMyLearningUrl(tab)),
      tabId: tab,
      title: I18n.text(`learningCenter.myLearning.tabs.${tab}`)
    }, `my-learning-nav_${tab}`))
  });
};